"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var AttachmentFeedIcon = function AttachmentFeedIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.75,43.45,46.22,77A16.49,16.49,0,0,1,22.9,53.65L59.34,17.21A10.31,10.31,0,0,1,73.92,31.78L43.31,62.4a4.13,4.13,0,0,1-5.84-5.83l27.7-27.7L60.8,24.5,33.1,52.19A10.31,10.31,0,0,0,47.68,66.77L78.29,36.16A16.49,16.49,0,0,0,55,12.83L18.52,49.28A22.68,22.68,0,0,0,50.59,81.35L84.13,47.82Z"
  }));
};

var _default = AttachmentFeedIcon;
exports["default"] = _default;
//# sourceMappingURL=AttachmentFeed.js.map